<template>
  <v-app-bar    app  clipped-right color="#604E05" dark>
    <!---/Toggle sidebar part -->
    <div  @click="(showhideLogo),(valueMenu)" >
      <v-app-bar-nav-icon

        class="pa-0 ml-0"
        @click="$vuetify.breakpoint.smAndDown ? setSidebarDrawer(!Sidebar_drawer) : $emit('input', !value);valueMenu"
      >
      </v-app-bar-nav-icon>
    </div>
    <!---Logo part -->
    <v-toolbar-title    class="pl-0 align-end  d-flex mt-2">
      <span v-if="!$vuetify.breakpoint.mobile"   class=" d-lg-none d-md-none d-xl-none logo-icon">
        <img src="@/assets/images/Icon_Docbit_peq.png" class="mr-sm-3 mr-4" />
      </span>
    </v-toolbar-title>
    <!---Logo part -->

    <div  class="row  ml-lg-1 ml-md-1 justify-start justify-lg-start justify-xl-start  align-end"  >
      <div class="text-md-subtitle-1 text-lg-sublime-1">
        {{titlepage}}
      </div>
          <v-divider  class=" mx-lg-2 mx-md-3 d-none d-xl-flex d-md-flex d-lg-flex d-xl-none mx-sm-8"
      color="#ffffff"
                      vertical ></v-divider>
      <div class="text-lg-subtitle-1  text-md-subtitle-1  d-none d-xl-flex d-md-flex d-lg-flex d-xl-none ">

    <v-breadcrumbs  :items="crumbs" divider=">" style="text-decoration: none" class="white--text pa-0 d-none d-inline ">
    </v-breadcrumbs>
      </div>
    </div>
    <v-spacer    />

    <div v-show="!$vuetify.breakpoint.xsOnly" style="width: 370px ;height:  40px;background-color: white; border-radius: 6px;display: flex">
    <div style="margin-right: 10px;border-right:2px solid #f3843c;width: 60px;height: 40px" >
      <!--              notificações-->
      <v-menu bottom left offset-y origin="top right" transition="scale-transition">
        <template v-slot:activator="{ on }">
          <v-btn  small dark icon v-on="on" >
            <v-badge  color="red" :value="hover"  transition="slide-x-transition"  :content="notifications.length" >
              <v-icon  class="ml-3 mt-3"  color="primary">mdi-bell</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <v-card>
          <h4 class="px-5 py-3 pt-2 font-weight-medium text-subtitle-1">Notificações</h4>
          <v-divider></v-divider>
          <v-list v-if="access === 'Administrador'" style="height: 280px; overflow-y: auto" >
            <v-list-item  v-for="(item, i) in notifications"  @click="readNotification(item.id,i)" :key="i" >
              <v-list-item-title>
                <div class="d-flex align-center py-3">
                  <div class>
                    <v-btn class="mr-3" depressed fab small dark color="success">
                      <v-icon dark>mdi-calendar-check</v-icon>
                    </v-btn>
                  </div>
                  <div>
                    <h4 class="font-weight-medium">Event today</h4>
                    <span class="text--secondary caption descpart d-block text-truncate">{{ JSON.parse (item.data).message }}</span>
                    <small class="text--secondary">{{elapsedTime(item.created_at)}}</small>
                  </div>
                </div>
              </v-list-item-title>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-card-actions v-if="hover" >
            <router-link to="/notifications" >
              <p>
                <span>Ver todas as notificações</span>
              </p>
            </router-link>
          </v-card-actions>
        </v-card>
      </v-menu>
    </div>
    <div style="width: 120px;height: 40px" >

      <div v-if="access === 'Gestores'" class="ma-0 pa-0 ml-2 mr-4 "  >
        <v-img  position="center" v-if="defaultClientLogo" :src="defaultClientLogo"  height="40" width="200"  contain></v-img>
        <v-img  v-else src="@/assets/images/Logo_menor.png"  height="40" width="200" contain></v-img>
      </div>

      <v-menu v-else-if="access === 'Administrador'"   bottom left offset-x origin="top right" transition="scale-transition">
        <template v-slot:activator="{ on }">
          <v-list-item-title class="ma-0 pa-0 ml-2 mr-4 " v-on="on" >
            <v-img  position="center" v-if="defaultClientLogo" :src="defaultClientLogo"  height="40" width="200"  contain></v-img>
            <v-img  v-else src="@/assets/images/Logo_menor.png"  height="40" width="200" contain></v-img>
          </v-list-item-title>
        </template>
        <v-list>
          <h4 class="px-5 pt-2 py-3 font-weight-medium text-subtitle-1">{{defaultClient}}</h4>
          <v-divider></v-divider>
          <v-list-item v-for="(item, i) in clients"  @click="updateDefaultClient(item)" :key="i" >
            <v-list-item-title>
              <div class="d-flex align-center justify-start py-3">
                <div>
                  <h4 class="font-weight-medium">{{ item.initials }}</h4>
                  <span class="text--secondary caption descpart d-block text-truncate">{{ }}</span>
                  <small class="text--secondary">{{item.name}}</small>
                </div>
              </div>
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <div v-else class="ma-0 pa-0 ml-2 mr-4 "  >
        <v-img  position="center" v-if="defaultClientLogo" :src="defaultClientLogo"  height="40" width="200"  contain></v-img>
        <v-img  v-else src="@/assets/images/Logo_menor.png"  height="40" width="200" contain></v-img>
      </div>
    </div>
    <div style="width: 120px;height: 40px" >
      <div class=" text-center black--text">
        <div   class="fonte text-truncate ">{{UserName}}</div>
        <div     class="subtitle text-truncate" style="text-overline:clip ;max-width: 130px" >{{position}}</div>
      </div>
    </div>
    <div class="text-center ml-1" style="width: 120px" >
      <v-menu bottom left offset-y origin="top right" transition="scale-transition">
        <template v-slot:activator="{ on }">
          <v-btn class="mt-2" small  icon v-on="on" >
            <v-avatar v-if="avatar"   size="30" >
              <v-img  :src="avatar" :alt="UserName" />
            </v-avatar>
            <v-avatar v-else color="primary"  size="30" >
              <span  class="text--white text-h6 font-weight-bold"   >{{UserName.substring(0,1)}}</span>
            </v-avatar>
          </v-btn>
        </template>
        <v-list nav dense>
        <v-list-item
          nav dense
          v-for="(item, i) in userprofile"
          :key="i"
          :to="item.to"
          @click="menuActionClick(item.action)"
        >
          <v-list-item-title  class="text-caption">{{ item.title }}</v-list-item-title>
        </v-list-item>
        </v-list>
      </v-menu>
    </div>
    </div>
    <div v-show="$vuetify.breakpoint.xsOnly" style="width: 100px ;height:  40px;background-color: white; border-radius: 6px;display: flex">
      <div style="border-right:2px solid #f3843c;width: 60px;height: 40px" >
      <!--              notificações-->
      <v-menu bottom left offset-y origin="top right" transition="scale-transition">
        <template v-slot:activator="{ on }">
          <v-btn small dark icon v-on="on" >
            <v-badge  color="red" :value="hover"  transition="slide-x-transition"  :content="notifications.length" >
              <v-icon  class="ml-6 mt-3"  color="primary">mdi-bell</v-icon>
            </v-badge>
          </v-btn>
        </template>
        <v-card>
          <h4 class="px-5 py-3 pt-2 font-weight-medium text-subtitle-1">Notificações</h4>
          <v-divider></v-divider>
          <v-list v-if="access === 'Administrador'" style="height: 280px; overflow-y: auto" >
            <v-list-item  v-for="(item, i) in notifications"  @click="readNotification(item.id,i)" :key="i" >
              <v-list-item-title>
                <div class="d-flex align-center py-3">
                  <div class>
                    <v-btn class="mr-3" depressed fab small dark color="success">
                      <v-icon dark>mdi-calendar-check</v-icon>
                    </v-btn>
                  </div>
                  <div>
                    <h4 class="font-weight-medium">Event today</h4>
                    <span class="text--secondary caption descpart d-block text-truncate">{{ JSON.parse (item.data).message }}</span>
                    <small class="text--secondary">{{elapsedTime(item.created_at)}}</small>
                  </div>
                </div>
              </v-list-item-title>
            </v-list-item>
          </v-list>
          <v-divider></v-divider>
          <v-card-actions v-if="hover" >
            <router-link to="/notifications" >
              <p>
                <span>Ver todas as notificações</span>
              </p>
            </router-link>
          </v-card-actions>
        </v-card>
      </v-menu>
    </div>
      <div style="width: 60px;height: 40px" >
        <v-menu bottom left offset-y origin="top right" transition="scale-transition">
          <template v-slot:activator="{ on }">
            <v-btn dark class="mt-2 ml-2" small icon v-on="on" >
              <v-avatar v-if="avatar"  size="30" >
                <v-img  :src="avatar" :alt="UserName" />
              </v-avatar>
              <v-avatar v-else color="primary"  size="30" >
                <span  class="text--white text-h6 font-weight-bold"   >{{UserName.substring(0,1)}}</span>
              </v-avatar>
            </v-btn>
          </template>
          <v-list nav dense>
            <v-list-item>
              <v-menu  bottom left offset-x origin="top right" transition="scale-transition">
                <template v-slot:activator="{ on }">
                  <v-list-item-title v-on="on" @click="on" >
                    <v-img  position="center" v-if="defaultClientLogo" :src="defaultClientLogo"  height="40" width="200"  contain></v-img>
                    <v-img  v-else src="@/assets/images/Logo_menor.png"  height="40" width="120" contain></v-img>
                    <div class="ml-4 text-center black--text">
                      <div   class="fonte text-truncate">{{UserName}}</div>
                      <div     class="subtitle text-truncate" style="text-overline:clip ;max-width: 130px" >{{position}}</div>
                    </div>
                  </v-list-item-title>

                </template>
                <v-list>
                  <h4 class="px-5 pt-2 py-3 font-weight-medium text-subtitle-1">{{defaultClient}}</h4>
                  <v-divider></v-divider>
                  <v-list-item v-for="(item, i) in clients"  @click="updateDefaultClient(item)" :key="i" >
                    <v-list-item-title>
                      <div class="d-flex align-center justify-start py-3">
                        <div>
                          <h4 class="font-weight-medium">{{ item.initials }}</h4>
                          <span class="text--secondary caption descpart d-block text-truncate">{{ }}</span>
                          <small class="text--secondary">{{item.name}}</small>
                        </div>
                      </div>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-list-item>
            <v-list nav dense>
              <v-list-item
                nav dense
                v-for="(item, i) in userprofile"
                :key="i"
                :to="item.to"
                @click="menuActionClick(item.action)"
              >
                <v-list-item-title  class="text-caption">{{ item.title }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-list>
        </v-menu>
      </div>
    </div>


  </v-app-bar>
</template>
<script>
  // Utilities
  import {mapMutations, mapState} from "vuex"
  import moment from 'moment'
  // import Echo from 'laravel-echo'
  // eslint-disable-next-line no-unused-vars
  import AuthService from '@/services/auth-service'

  export default {
        name: "Header",

        components: {},

        props: {
            value: {
                type: Boolean,
                default: false
            }
        },

        data: () => ({
            showLogo: true,
            showMenu:true,
            items:[
                {
                    text: "Dashboard",
                    disabled: false
                },
                {
                    text: "main",
                    disabled: true
                }
            ],
            showSearch: false,
            closeOnContentClick: false,
            notifications: [],
            hover:false,
            messages: [
            ],
          userprofile: [
            { title: "Perfil", to: "/countersign" },
            { title: "Troca Senha", to: "/change-password" },
            { title: "Sair", to: "",action:"logout" },
          ],
            href() {
                return undefined;
            }
        }),
        watch:{
            notifications:{
                handler: function (val) {
                    if(val.length === 0) {
                        this.hover = false
                    }else{
                        this.hover = true
                    }
                },
                deep:false
            }
        },
        computed: {
            titlepage: function(){
             var title = this.$route.meta.TitlePage
             return  title

            },
            crumbs: function() {
                let pathArray = this.$route
                let items = pathArray.meta.items
              let no = items
              return no
            },
            clients () {
                return this.$store.state.userClients
            },
            defaultClient () {
                return this.$store.state.defaultClient.name
            },
            defaultClientLogo(){
              return this.$store.state.defaultClient.logo
             },
             avatar(){
              return this.$store.state.userAvatar
             },
            UserName(){
                return this.$store.state.userName
            },
             access () {
                return this.$store.state.access.name
                },
             position () {
              return this.$store.state.possition.name ?  this.$store.state.possition.name : this.$store.state.possition
              },
            ...mapState(["Sidebar_drawer"])
        },
        apollo: {
            notifications: {
                query: require('@/graphql/queries/User.gql').UserNotificationQuery,
                update: (data) => {
                    return data.me.user_notifications
                }
            }
        },
        methods: {
          menuActionClick(action){
            if(action === "logout"){
              AuthService.logout().then(()=>{
                this.$router.push('/')
              })
            }
          },
         valueMenu(){
          //console.log('teste')
         },
            updateDefaultClient (client) {
                this.$apollo.mutate({
                    mutation: require('@/graphql/mutations/User.gql').UpdateUserClientMutation,
                    variables: {
                        id: this.$store.state.userID,
                        client: client.id
                    }
                }).then(() => {
                    // this.$vs.notify({title:'Sucesso', text:'Cliente alterado com Sucesso!', color:'success'})
                    this.$toasted.show(
                        'Cliente alterado com Sucesso!',
                        {type:'success',icon:'mdi-chat-alert-outline'})
                    this.$router.go('dashboard/dashboard-main')
                    this.$store.dispatch('updateDefaultClient', client)
                }).catch((error) => {
                    console.error(error)
                })
            },
            readNotification (uid, el) {
                this.$apollo.mutate({
                    mutation: require('@/graphql/mutations/Notification.gql').UpdateMutation,
                    variables: {
                        id: uid,
                        read_at: moment().format('YYYY-MM-DD')
                    }
                }).then(() => {
                    this.notifications.splice(el, 1)
                }).catch((error) => {
                    console.error(error)
                })
            },
            elapsedTime (startTime) {

                const x        = new Date(startTime)
                const now      = new Date()
                let timeDiff = now - x
                timeDiff    /= 1000

                const seconds = Math.round(timeDiff)
                timeDiff    = Math.floor(timeDiff / 60)

                const minutes = Math.round(timeDiff % 60)
                timeDiff    = Math.floor(timeDiff / 60)

                const hours   = Math.round(timeDiff % 24)
                timeDiff    = Math.floor(timeDiff / 24)

                const days    = Math.round(timeDiff % 365)
                timeDiff    = Math.floor(timeDiff / 365)

                const years   = timeDiff

                if (years > 0) {
                    return `${years + (years > 1 ? ' Years ' : ' Year ')}ago`
                } else if (days > 0) {
                    return `${days + (days > 1 ? ' Days ' : ' Day ')}ago`
                } else if (hours > 0) {
                    return `${hours + (hours > 1 ? ' Hrs ' : ' Hour ')}ago`
                } else if (minutes > 0) {
                    return `${minutes + (minutes > 1 ? ' Mins ' : ' Min ')}ago`
                } else if (seconds > 0) {
                    return seconds + (seconds > 1 ? ' sec ago' : 'just now')
                }

                return 'Agora mesmo'
            },

            logout () {
                localStorage.removeItem('userInfo')

                // This is just for demo Purpose. If user clicks on logout -> redirect
                this.$router.push('/pages/login').catch(() => {})
            },
            ...mapMutations({
                setSidebarDrawer: "SET_SIDEBAR_DRAWER"
            }),
            showhideLogo: function() {
                this.showLogo = !this.showLogo;
            },
            showhideMenuPrifile: function() {
                this.showLogo = !this.showLogo;
            },
            searchbox: function() {
                this.showSearch = !this.showSearch;
            }
        },
        async mounted () {
        //     this.$apollo.queries.notifications.refetch();
        //     const token = localStorage.getItem('apollo-token')
        //     this.echo = new Echo({
        //         broadcaster: 'pusher',
        //         key: 'f4e308ab83f471b56ec3',
        //         cluster: 'us2',
        //         forceTLS: true,
        //         encrypted: true,
        //         authEndpoint: `${backEndBaseURL}/broadcasting/auth`,
        //         auth: {
        //             headers: {
        //                 Authorization: `Bearer ${token}`
        //             }
        //         }
        //     });
        //     const data = await AuthService.user()
        //
        //     const channel = `App.User.${data.id}`
        //
        //     this.echo.private(channel).notification((object) => {
        //         this.$apollo.queries.notifications.refetch()
        //         this.$toasted.show(
        //             object.message,
        //             {type:'success',icon:'mdi-chat-alert-outline'})
        //     })
        }
    };
</script>

<style lang="scss">
  .v-application #main-sidebar.theme--dark.white{
    background:#363636!important;
  }
  .hidelogo{
    display: none;
  }
  .v-application a {
    color: #f1f3e8;
  }
  .searchinput{
    position: absolute;
    width: 100%;
    margin: 0;
    left: 0;
    z-index: 10;
    padding: 0 15px;
  }
  @media screen and (max-width: 900px) and (min-width: 600px) {
    div.example {
      font-size: 50px;
      padding: 50px;
      border: 8px solid black;
      background: yellow;
    }
  }
  .descpart{
    max-width:220px;
  }
  .header{
   color: #363636;
   display: flex;
   border-radius: 10px;
   background-color: #ffffff;
  }
.fonte {
  font-size: 90%;
  font-weight: bold;
}
  .subtitle {
    font-size: 12px;
  }

  .vl {
    border-left: 6px solid green;
    height: 500px;
    position: absolute;
    left: 50%;
    margin-left: -3px;
    top: 0;
  }

</style>
